import { render } from "./index.vue?vue&type=template&id=92c2a176&bindings={\"flash\":\"props\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "92c2a176"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92c2a176')) {
    api.reload('92c2a176', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=92c2a176&bindings={\"flash\":\"props\"}", () => {
    api.rerender('92c2a176', render)
  })

}

script.__file = "resources/js/Components/FlashMessage/index.vue"

export default script